import { SimpleGrid } from '@mantine/core'
import { IconLock } from '@tabler/icons-react'
import { GameButton } from '../common/GameButton'

/**
 * Decision choices for the current beat.
 *
 * When `locked` is true the player is revisiting an already-committed decision:
 * the chosen option stays highlighted with a lock affordance and every option
 * is non-interactive, so a previous answer reads as fixed for the session.
 */
export function ChoiceButtons({ choices = [], selectedChoice, onSelect, locked = false }) {
  return (
    <SimpleGrid cols={2} spacing="sm" styles={{ root: { gridAutoRows: '1fr' } }}>
      {choices.map((choice) => {
        const isChosen = selectedChoice?.id === choice.id
        return (
          <GameButton
            key={choice.id}
            selected={isChosen}
            onClick={locked ? undefined : () => onSelect(choice)}
            fullWidth
            // Keep the chosen option fully lit; fade the roads not taken so the
            // locked answer is unmistakable without greying everything out.
            leftSection={locked && isChosen ? <IconLock size={14} /> : undefined}
            styles={{
              root: {
                textAlign: 'left',
                height: '100%',
                padding: '10px 16px',
                whiteSpace: 'normal',
                cursor: locked ? 'default' : 'pointer',
                opacity: locked && !isChosen ? 0.35 : 1,
                pointerEvents: locked ? 'none' : 'auto',
                ...(locked ? { '&:hover': {} } : {}),
              },
              label: {
                whiteSpace: 'normal',
              },
            }}
          >
            {choice.text}
          </GameButton>
        )
      })}
    </SimpleGrid>
  )
}
